import React from 'react'
import { InfoFillIcon } from '@frontend/pole-ui/lib/components/Icon/svg/InfoFillIcon'
import omit from 'lodash/omit'
import type { ICustomizedFormStepProps } from '@/components/composed/forms/CustomizedForms/interfaces'
import type { IPolicyAgreementProps } from '@/components/ui/fields/PolicyAgreement/types'
import type { TFinancingOfferModalStepsAdapter } from './types'

export const defaultFinancingOfferModalStepsAdapter: TFinancingOfferModalStepsAdapter = (steps, { onFormInteraction }) =>
  steps.map(step => ({
    ...step,
    fields: step.fields.map(field => {
      let gtmHandler

      if (field.fieldType === 'regionDropdown') {
        gtmHandler = { onOpen: () => onFormInteraction(field.fieldType) }
      } else if (field.fieldType === 'datePicker') {
        gtmHandler = { onSelect: () => onFormInteraction(field.name) }
      } else {
        gtmHandler = { onFocus: () => onFormInteraction(field.name) }
      }

      const controlledField = { ...field, ...gtmHandler }

      if (field.fieldType === 'checkbox') return omit(controlledField, ['activeControlStyle', 'borderColorStyle', 'markColor'])

      if (field.name === 'loanAmount.value') return { ...controlledField, shouldBeTouchedBeforeError: true }

      if (field.fieldType === 'policyAgreement') {
        const initialField = field as IPolicyAgreementProps

        return initialField
      }

      return controlledField
    }),
    submitButton: {
      ...step.submitButton,
      modifiers: ['green'],
    },
  }))

export const advancePaymentOfferModalStepsAdapter: TFinancingOfferModalStepsAdapter = (steps, context) => {
  const extendedSteps: ICustomizedFormStepProps[] = steps.map(step => {
    return {
      ...step,
      fields: step.fields.map(field => {
        switch (field.fieldType) {
          case 'regionDropdown':
          case 'text': {
            return {
              ...field,
            }
          }
          case 'infoText': {
            return {
              ...field,
              className: 'financingOfferModal__infoText',
              iconProps: {
                component: <InfoFillIcon />,
                className: 'financingOfferModal__infoIcon',
              },
            }
          }
          default: {
            return field
          }
        }
      }),
      submitButton: {
        ...step.submitButton,
        modifiers: ['green', 'full-width-mobile'],
      },
    }
  })

  return defaultFinancingOfferModalStepsAdapter(extendedSteps, context)
}
